module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-backplates.23ca0b2d.png";